import { SHOW_MODAL, HIDE_MODAL,SET_MODAL_CONTENT } from "../../types";

export default (state, action) => {
 try{
  const newState = { ...state }
  switch (action.type) {
    case SHOW_MODAL:
      return {
        modalShow: true,
      };
    case HIDE_MODAL:
      return {
        modalShow: false,
      };
    case SET_MODAL_CONTENT:
        //console.log(action)
        newState.showEditReceiver = action.showEditReceiver
        return newState
   /* case SET_MODAL_TITLE:
        newState.modalTitle = action
        return newState*/

    default:
      return state;
  }
  }
  catch(error){
    //console.error(error)
  }
};
